// extracted by mini-css-extract-plugin
module.exports = {"newPrice":"_3KxDFc","oldPrice":"_1uZi_K"};